import { cn } from '@/lib/cn';

/**
 * The Miraxis wordmark.
 *
 * The brand ships only a PNG (docs/brand/wordmark-dark.png) with a #020713 background baked in,
 * which clashes with the app's --chrome. public/wordmark.png is that asset with the background
 * keyed out and the two brand colors preserved, so the real letterforms are used rather than
 * hand-traced approximations. Aspect ratio 1752x128.
 */
export function Wordmark({ height = 16, className }: { height?: number; className?: string }) {
  return (
    <img
      src="/wordmark.png"
      alt="Miraxis"
      height={height}
      style={{ height, width: height * (1752 / 128) }}
      className={cn('select-none', className)}
    />
  );
}

/** The standalone "A" glyph, for tight spaces. */
export function Mark({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <img
      src="/favicon.png"
      alt="Miraxis"
      width={size}
      height={size * (50 / 62)}
      className={cn('select-none', className)}
    />
  );
}
